import { createContext } from 'react';
import { CLIENTS } from '../../helpers/constants';

const initialConfig = {
  client: CLIENTS.CLEAROUT.NAME
}

export default createContext(initialConfig)